import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=aa60e7ee&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&lang=ts&"
export * from "./FilePreview.vue?vue&type=script&lang=ts&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=aa60e7ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa60e7ee",
  null
  
)

export default component.exports